export default {
  students: [],
  teachers: [],
  teacher: {},
  classrooms: [],
  subjectsByCycles: {},
}